import { render } from "./zoom-message.vue?vue&type=template&id=5802ee76&scoped=true&ts=true"
import script from "./zoom-message.vue?vue&type=script&lang=ts"
export * from "./zoom-message.vue?vue&type=script&lang=ts"

import "./zoom-message.vue?vue&type=style&index=0&id=5802ee76&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5802ee76"]])

export default __exports__